import * as React from 'react';
import { connect } from 'react-redux';

import { IOption, MediaGalleryAppState } from '../../classes/index';
import { Dispatch } from 'redux';
import { IMediaGalleryItem, MediaGalleryItemType, IMediaGalleryImage, IMediaGalleryVideo } from '../../classes/media-gallery';

import GalleryImageView from '../../views/gallery-image';
import GalleryVideoView from '../../views/gallery-video';
import { openModal, setModalContent } from '../redux/actions/modal';

export interface ExternalProps {
    data: IMediaGalleryItem;
}

export interface StateToProps {
}

interface DispatchToProps {
    openModal: () => any;
    setContent: (content: IMediaGalleryItem) => any;
}

interface MediaGalleryItemState {
}

type MediaGalleryItemProps = ExternalProps & StateToProps & DispatchToProps;

export class GalleryItemComponent extends React.Component<MediaGalleryItemProps, MediaGalleryItemState> {
    constructor(props: MediaGalleryItemProps) {
        super(props);
    }

    private getRelevantView() {
        if (this.props.data.media && this.props.data.media.length > 0) {
            switch (this.props.data.type) {
                case MediaGalleryItemType.IMAGE: {
                    return <GalleryImageView data={this.props.data.media[0] as IMediaGalleryImage} />
                }

                case MediaGalleryItemType.VIDEO: {
                    return <GalleryVideoView data={this.props.data.media[0] as IMediaGalleryVideo} />
                }

                default: {
                    return null;
                }
            }
        }

        return null;
    }

    onClick(evt: React.MouseEvent<HTMLButtonElement>) {
        this.props.openModal();
        this.props.setContent(this.props.data);
    }

    private boundOnClick = this.onClick.bind(this);

    render() {
        return (
            <figure className="item item-media item-effect media-gallery-item" onClick={this.boundOnClick}>
                {this.getRelevantView()}

                <div className="item-content">
                    <figcaption>
                        <div className="item-season">
                            {this.props.data.seasonTag}
                        </div>
                        <div className="item-title">
                            {this.props.data.galleryTitle}
                        </div>
                    </figcaption>
                    <button className="btn-primary" onClick={this.boundOnClick} >{this.props.data.buttonText}</button>
                </div>
            </figure>
        )
    }
}

function mapDispatchToProps(dispatch: Dispatch<MediaGalleryAppState>, ownProps: ExternalProps): DispatchToProps {
    return {
        openModal: () => dispatch(openModal()),
        setContent: (content: IMediaGalleryItem) => dispatch(setModalContent(content))
    }
}

export default connect<null, DispatchToProps>(null, mapDispatchToProps)(GalleryItemComponent);


// WEBPACK FOOTER //
// ./app/media-gallery/components/gallery-item.tsx